const MigrationSteps = {
  PaymentOptions: 'payment-options',
  Activation: 'activation',
  Activated: 'activated',
};

export default MigrationSteps;
